import React from "react";
import ReactPlayer from 'react-player';

const AndroidJavaRealisations = () => {
    return (
        <div className="seresa mt-2">
            <h5 className="text-white pl-2">Applications mobiles Android-Java réalisées pendants des projets de formation (en solo)</h5>
            <h5 className="text-white pl-2">Appli Quizz</h5>
            <div className="row">
                <div className="col-md-6">
                    <div className="card2 col-md-12 my-1">
                        <p className="text-white text-center">Déscription</p>
                        <p className="text-white">Application Quiz avec création de compte utilisateur, enregistrement des données dans une base de données SQLite, permet de jouer au Quiz, un CRUD complet de la classe utiliateur, mise à jour de score dans la base de données apres chaque partie.<br/>Utlisation des SharedPreferences pour gerer certaines fonctionnalités (comme la déconnexion par exemples). </p>
                    </div>
                </div>
                <div className="col-md-6 ">
                    <div className="card1 col-md-12 my-1">
                        <p className="text-white text-center">Démonstration Application Quiz</p>
                        <ReactPlayer style={{ margin: 'auto', padding: 5 }} controls={true}
                            url='https://portfoli-omar-data.s3.eu-west-3.amazonaws.com/quizzomarrec.mp4'
                            width='100%'
                            height='300px'
                            fluid={"true"}
                        />
                    </div>
                </div>
            </div>
            <h5 className="text-white pl-2">Appli Calculator</h5>
            <div className="row">
                <div className="col-md-6 ">
                    <div className="card1 col-md-12 my-1">
                        <p className="text-white text-center">Démonstration Application Calculator</p>
                        <ReactPlayer style={{ margin: 'auto', padding: 5 }} controls={true}
                            url='https://portfoli-omar-data.s3.eu-west-3.amazonaws.com/calculattoromarrec.mp4'
                            width='100%'
                            height='300px'
                            fluid={"true"}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="card2 col-md-12 my-1">
                        <p className="text-white text-center">Déscription</p>
                        <p className="text-white">Aapplication Calculatrice, permet de réaliser les opérations de base, enregistriment la dernière opération dans les "SharedPreferences" associée à un utilisateur, pour qu'on lui affiche à son retour sur l'aplication.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AndroidJavaRealisations;